<template>
  <div class="rcs__review-card" :class="{'rcs__review-card--miniView':miniView, 'border-light':miniView}">
    <div class="review-card__head">
      <img :src="bizLogo(review.business_logo)">
      <div :class="{'margin-left-8':isDesktop || isTablet, 'margin-left-10':isMobile || miniView, 'color-gray2':miniView}">
        <div class="has-text-weight-bold" :class="{'color-blue-dark':miniView, 'font-size-20':isDesktop || isTablet, 'font-size-12':isMobile}">{{ review.business_name }}</div>
        {{ review.industry_name }}
      </div>
    </div>
    <div class="review-card__separator"></div>
    <div class="review-card__body">
      <div class="review-card__star-row">
        <rating :stars="getIntegerRating"/>
        <div>{{ trimText(review.authorDisplayName, authorCharsShow) }} | <span class="is-italic">{{ review.created_at }}</span></div>
      </div>
      <div class="is-clearfix" :class="{'padding-left-5': isDesktop || isTablet}">
        <h2 v-if="miniView" class="rc_b_head">{{ review.review_title }}</h2>
        <div v-else class="rc_b_head">{{ review.review_title }}</div>
        <div v-if="miniView" class="rc__body">{{ review.review_content }}</div>
        <div v-else v-text="trimText(review.review_content, reviewTextCharsShow[deviceType])"></div>
        <div class="rc_b_reply-row" v-if="review.bizFirstPublicmessage">
          <div class="has-text-weight-bold" :class="{'margin-bottom-22': isDesktop || isTablet, 'margin-bottom-9': isMobile}">{{ review.business_name }}’s reply:</div>
          <div v-html="trimText(review.bizFirstPublicmessage.body, reviewReplyCharsShow)"></div>
        </div>
        <div v-if="miniView" class="separator"></div>
        <router-link class="link--v2" :class="{'is-pulled-right': !miniView, 'padding-top-24': isDesktop, 'padding-top-19': isMobile || isTablet}"
                     :to="{ name: 'Reviewdetail', params: { business: review.business_slug, permalink: review.permalink }}">See
          more
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>

import {misc} from '@/mixins'
import {Rating} from '@/components'

export default {
  name: 'BizReviewCard',
  mixins: [misc],
  components: {
    Rating
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    miniView: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      reviewTextCharsShow: {
        'desktop': 500,
        'tablet': 230,
        'mobile': 230
      },
      reviewReplyCharsShow: 120,
      authorCharsShow: 10
    }
  },
  computed: {
    isMobile () {
      return this.baseIsMobile && !this.miniView
    },
    isDesktop () {
      return this.baseIsDesktop && !this.miniView
    },
    isTablet () {
      return this.baseIsTablet && !this.miniView
    },
    getIntegerRating () {
      if (Number.isInteger(this.review.review_rating)) {
        return this.review.review_rating
      }
      if (typeof this.review.review_rating === 'string') {
        const parsed = parseInt(this.review.review_rating);
        return isNaN(parsed) ? 0 : parsed;
      }
      return 0
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";
@import "@/assets/scss/utilities/_misc.scss";

@mixin biz-logo--mobile {
  max-width: 30px;
  border-radius: 50%;
}

@mixin separator {
  border-radius: 2.5px;
  background-color: map-get($colors, 'blue-dark');
}

@mixin star-row--mobile {
  display: flex;
  flex-direction: column;
}

.rcs__review-card:not(.rcs__review-card--miniView) {
  width: 499px;
  padding: 20px 25px 22px 21px;
  border-radius: 25px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  color: map-get($colors, 'gray');
  margin-bottom: 35px;

  @include tablet {
    margin-bottom: 50px;
  }

  @include mobile {
    padding: 12px 13px 22px 13px;
    border-radius: 15px;
    margin-bottom: 11px;
    margin-top: 9px;
  }

  &:nth-of-type(odd) {
    margin-right: 42px;
  }

  .review-card__head {
    font-size: 18px;
    line-height: 23px;
    display: flex;

    @include mobile {
      font-size: 11px;
      line-height: normal;
    }

    img {
      max-width: 46px;
      border-radius: 50%;

      @include mobile {
        @include biz-logo--mobile
      }
    }
  }

  .review-card__separator {
    @include separator;
    height: 5px;
    margin: 18px 0 29px 3px;


    @include mobile {
      height: 2px;
      margin: 6px 0 6px 2px;
    }
  }

  .review-card__body {
    padding: 0 5px 0 6px;
    font-size: 14px;

    @include mobile {
      font-size: 11px;
      padding: 0 0 0 0;
    }

    .review-card__star-row {
      display: flex;
      justify-content: space-between;

      @include mobile {
        @include star-row--mobile;

        .star-new {
          margin-bottom: 2px;
          margin-left: -3px;
        }
      }

      > > > .star-new li {
        font-size: 1.2em;

        @include mobile {
          font-size: 1em;
        }
      }
    }

    .rc_b_head {
      font-weight: bold;
      font-size: 18px;
      margin: 11px 0 12px;

      @include mobile {
        font-size: 12px;
        margin: 8px 0;
      }
    }

    .rc_b_reply-row {
      margin-left: 13px;
      margin-top: 24px;
      padding-left: 10px;
      border-left: 2px solid #707070;

      @include mobile {
        border-width: 1.5px;
        margin-left: 0;
        margin-top: 15px;
      }
    }
  }
}

.rcs__review-card--miniView {
  height: 281px;
  padding: 12px 13px 13px 12px;
  border-radius: 15px;

  @include tablet {
    height: 263px;
    padding: 10px 10px 10px 10px;
  }

  @include mobile {
    height: 218px;

  }

  .review-card__head {
    font-size: 10px;
    display: flex;
    margin-left: 1px;

    img {
      @include biz-logo--mobile
    }
  }

  .review-card__separator {
    @include separator;
    height: 1px;
    margin: 11px 0 9px;
  }

  .review-card__body {
    font-size: 12px;
    margin-left: 1px;

    @include not-desktop {
      font-size: 10px;
    }

    @include mobile {
      .link--v2 {
        font-size: 11px;
      }
    }

    .review-card__star-row {
      @include star-row--mobile;

      .star-new {
        margin-left: -4px;
        margin-bottom: 1px;
      }

      > > > .star-new li {
        font-size: 1.1em;
      }
    }

    .rc_b_head {
      font-weight: bold;
      margin: 8px 0 9px;
      color: map-get($colors, 'blue-dark');
      @include box-line-clamp(1);

      @include tablet {
        font-size: 11px;
      }

      @include mobile {
        font-size: 12px;
        color: map-get($colors, 'gray');
      }
    }

    .rc__body {
      font-size: 11px;
      @include box-line-clamp(5);

      @include mobile {
        @include line-clamp(2);
      }
    }

    .separator {
      margin: 13px 0 7px -1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reviewCards/BizReviewCard.vue